import { FeatureService } from './../../../../../core/services/feature/feature.service';
import {
  Component,
  OnInit,
  ViewChild,
  Input,
  EventEmitter,
  Output,
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MasterHomeCreateProfileService } from '../../service/master-home-create-profile.service';
@Component({
  selector: 'table-create-profile',
  templateUrl: './table-create-profile.component.html',
  styleUrls: ['./table-create-profile.component.scss'],
})
export class TableCreateProfile implements OnInit {
  constructor(
    private serviceHomeCreateProfile: MasterHomeCreateProfileService,
    private featureService:FeatureService
  ) {}
  dataTableInfo: any;
  allChecked: boolean = false;
  dataTableFilter: any;
  filterAutoComplete: any;
  showSearch: boolean = false;
  isAsc: boolean = true;

  @ViewChild('sort', { static: false }) sort: MatSort;
  @Input() dataTable: Array<any>;
  @Input() dataRetrieveNode: string;
  @Input() idCheckboxHeader: number;
  @Output() rolesSelected: EventEmitter<any> = new EventEmitter<any>();
  //Output to emit when Relatórios selection changes
  @Output() relatoriosSelectionChanged = new EventEmitter<boolean>();
  @Output() allRelatoriosToggled = new EventEmitter<boolean>();

  ngOnInit() {
    this.getDataTable();
    this.showSearch = this.dataTable.length > 8 ? true : false;
    this.dataTableInfo.sort = this.sort;
  }

  ngAfterViewInit() {
    this.dataTableInfo.sort = this.sort;
  }

  getDataTable() {
    this.dataTable.forEach(data => {
      if (!data.checked) {
        return (data.checked = false);
      }
    });
    let dataTableSort = this.dataTable;
    dataTableSort.forEach(element=>{
      element.name = this.featureService.translatorService.translateEnumItem(element.name,'PermissionsType')

    })    
    dataTableSort.sort((a, b) => {
      if (a.name === null) {
        a.name = '';
      }
      if (b.name === null) {
        b.name = '';
      }
      return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
    })
    this.dataTableInfo = new MatTableDataSource(dataTableSort);

    this.dataTableInfo.sort = this.sort;
    this.isAllSelected();
  }

  filterDataTableInput(event) {
    this.dataTableInfo.filterPredicate = (data, filter) => {
      data.name = this.featureService.translatorService.translateEnumItem(data.name,'PermissionsType')
      if (data.name === null || data.name === undefined) {
        data.name = '';
      }
      return data.name.toLowerCase().includes(filter.toLowerCase());
    };
    this.dataTableFilter = (event.target as HTMLInputElement).value;
    this.dataTableInfo.filter = this.dataTableFilter;

    if (this.dataTableFilter.length > 0 && this.dataTableFilter.length % 2 == 0) {
      this.filterAutoComplete = this.dataTableInfo.filteredData;
    } else if (this.dataTableFilter.length == 0) {
      this.filterAutoComplete = [];
    }
  }


  someComplete() {
    return this.dataTableInfo.data?.some(ele => ele.checked == true);
  }

  toogleAllSelected() {
    this.allChecked = !this.allChecked;
    this.dataTableInfo.data.forEach(row => (row.checked = this.allChecked));
    this.dataTableInfo.data.forEach((row) => {
      row.checked = this.allChecked
      // If this is the Relatorios permission, emit the event
      if (row.name === 'Relatórios'  ||row.name ==='Reports') {
        this.allRelatoriosToggled.emit(this.allChecked);
      }
    });
    this.onSelectRole();
  }

  isAllSelected() {
    this.allChecked = this.dataTableInfo.data.every(row => row.checked == true);
    this.onSelectRole();
  }

  toggleSelection(row) {
    this.dataTableInfo.data.forEach(data => {
      if (row.id === data.id) {
        row.checked = !row.checked;
      }
    });
    this.isAllSelected();
    this.onSelectRole();
    if (row.name === 'Relatórios'  ||row.name ==='Reports') {
      this.relatoriosSelectionChanged.emit(row.checked);
    }
  }

  onSelectRole() {
    this.serviceHomeCreateProfile.setRoles(
      this.dataTableInfo.data,
      this.dataRetrieveNode,
    );
    this.rolesSelected.emit(this.dataTableInfo.data);
  }

  sortData() {
    this.isAsc = !this.isAsc;
    this.dataTableInfo.data = this.dataTableInfo.data.sort((a, b) => {
      return this.compare(a.name, b.name, this.isAsc);
    });
  }

  compare(a, b, isAsc) {
    if (a === null) {
      a = '';
    }
    if (b === null) {
      b = '';
    }
    return (a.toLowerCase() > b.toLowerCase() ? 1 : -1) * (isAsc ? 1 : -1);
  }
  isSelected(row) {
    const isSelected = JSON.parse(row.checked);
    return isSelected;
  }
}
